import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from "js-cookie"
import router from '@/router'

let api = require("@/api/api.js")

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: Cookies.get("payapp_token") || "",
    code: Cookies.get("payapp_code") || "",
    companyId: Cookies.get("payapp_companyId") || "",
    expireWarn: Cookies.get("payapp_expireWarn") || "",
    userInfo:Cookies.get("payapp_userInfo")?JSON.parse(Cookies.get("payapp_userInfo")):{}
  },
  mutations: {
    login(state, code) {
      if (state.code != code) {
        console.log("重新进入")
        // 如果code不一样代表重新登录
        // 清空之前的token、防止调用首页接口报错
        state.token = ""
        Cookies.remove("payapp_code")
        state.code = code
        Cookies.set("payapp_code",code)
        api.post("/payment/auth/user/noauth/qywx/login", {
          reqData: {
            code: code,
          },
        }).then(res => {
          if (res.repCode == '0000') {
            Cookies.set("payapp_token", res.repData.token)
            Cookies.set("payapp_companyId", res.repData.companyId)
            Cookies.set("payapp_userInfo", JSON.stringify(res.repData))
            state.token = res.repData.token
            state.expireWarn = res.repData.expireWarn
            state.companyId = res.repData.companyId
            state.userInfo = res.repData
          } else {
            router.push("/no404")
          }
        })
      }else{
        console.log("未重新进入")
        // console.log(state)
        // Cookies.set("payapp_token",state.token)
        // Cookies.set("payapp_companyId",state.companyId)
        // Cookies.set("payapp_userInfo", JSON.stringify(state.userInfo))
        // if(){}
      }
    },
    // setToken(state, payload) {
    //   state.token = payload
    // },
    loginOut(state) {
      console.log("loginout")
      Cookies.remove("payapp_token")
      state.token = ""
    }
  },
  actions: {
  },
  modules: {
  }
})
